import { RefreshCw } from "lucide-react";
import React, { useState } from "react";

import { hardReload } from "@/lib/hard-reload";

/** Версия фронта (коммит + время сборки) для диагностики кеша на ТСД + кнопка
 * «жёсткого» обновления (`lib/hard-reload.ts`). */
export function BuildVersion(): React.ReactElement {
  const [busy, setBusy] = useState(false);
  const version = __APP_VERSION__;
  const built = formatBuildTime(__BUILD_TIME__);

  function onReload(): void {
    setBusy(true);
    void hardReload();
  }

  return (
    <div className="flex items-center gap-2 whitespace-nowrap text-[11px] text-muted-foreground">
      <span title={`Собрано: ${built}`}>
        v <span className="font-mono">{version}</span>
      </span>
      <button
        type="button"
        onClick={onReload}
        disabled={busy}
        className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 hover:bg-accent hover:text-accent-foreground disabled:opacity-50"
        aria-label="Обновить приложение (очистить кеш)"
        title="Обновить приложение (очистить кеш ТСД)"
      >
        <RefreshCw className={busy ? "size-3 animate-spin" : "size-3"} />
        обновить
      </button>
    </div>
  );
}

function formatBuildTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
